<eds-simple-modal
  modalAriaLabel="{{ 'common.modal-open' | translate }}"
  closeAriaLabel="{{ 'common.modal-close' | translate }}"
  aria-modal="true"
  size="small"
  [modalId]="'watchlistModal'"
  [showModal]="!!showModal"
  [config]="modalConfig"
  (onClose)="handleCloseModal()"
>
  <div modal-header>
    <eds-title [level]="5" size="h6">{{
      brLabels["add-to-watchlist-title"]
    }}</eds-title>
    <p>
      {{ brLabels["add-to-watchlist-summary"] }}
    </p>
  </div>
  <div modal-body>
    <!--search bar-->
    <div edsSpacing="md" edsPadding edsPaddingTop="xs">
      <eds-search
        #onPageSearch
        [label]="brLabels['search-label']"
        [placeholder]="brLabels['watchlist-search-placeholder']"
        [clearText]="brLabels['clear']"
        [hasDropdown]="true"
        [autocompleteState]="'off'"
        (searchTerm)="findAFund($event)"
      ></eds-search>
    </div>
    <div aria-live="polite">
      <ng-container *ngIf="searchItems?.length > 0">
        <table class="table">
          <thead class="table__thead">
            <tr class="table__tr">
              <th class="table__th">
                <span class="small">{{ brLabels["product-name"] }}</span>
              </th>
              <th class="table__th">
                <span class="small">{{ brLabels["share-classes"] }}</span>
              </th>
            </tr>
          </thead>
          <tbody class="table__body">
            <tr
              class="table__tr table__tr--no-bg table__tr--border-bottom"
              *ngFor="let fund of searchItems"
            >
              <td class="table__td">
                {{ fund.fundName }}
              </td>
              <td class="table__td">
                <span *ngFor="let shareClass of fund.shareClasses">
                  <button
                    [hasIcon]="false"
                    edsButton="secondary"
                    [noMargin]="true"
                    size="shareclass"
                    data-analytics-no-event="true"
                    [attr.aria-label]="shareClass?.ariaTitle"
                    (click)="
                      addToWatchlist(
                        fund,
                        shareClass.fundShareClassId,
                        shareClass.shareclass
                      )
                    "
                  >
                    {{ shareClass.shareclass }}
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          *ngIf="isViewMoreBtnVisible"
          edsFlexbox
          justifyContent="flex-end"
          edsPadding
          edsPaddingTop="sm"
          edsPaddingBottom="sm"
        >
          <button
            [hasIcon]="false"
            edsButton="secondary"
            size="compact"
            [noMargin]="true"
            (click)="viewMore()"
            data-analytics-no-event="true"
          >
            {{ brLabels["view-more"] }}
          </button>
        </div>
      </ng-container>
    </div>
    <!-- no product available -->
    <p *ngIf="isSearchEmpty && !isProductAlreadyExist">
      {{ brLabels["empty-search-result"] }}
    </p>
    <!-- product already exist in focus list -->
    <p *ngIf="isProductAlreadyExist">
      {{ brLabels["product-already-exist"] }}
    </p>

    <!-- error variant -->
    <div *ngIf="hasError" edsPadding edsPaddingBottom="lg">
      <p class="pre-title pre-title--light" edsSpacing="none">
        {{ brLabels["error"] }}
      </p>
    </div>
  </div>
</eds-simple-modal>
